function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2201 1.0196C16.2298 1.01181 16.2324 0.998074 16.2261 0.987322C16.2198 0.97657 16.2066 0.972054 16.195 0.976712L11.1041 3.02934C11.0977 3.03193 11.0926 3.03705 11.0901 3.04349L9.93816 5.99085C9.93402 6.00144 9.93751 6.01349 9.94667 6.02022C9.95583 6.02696 9.96837 6.0267 9.97724 6.01959L16.2201 1.0196Z",
  fill: "#F3F4F6",
  stroke: "#E2761B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.79065 1L7.98467 6.04736L6.88644 3.05263L1.79065 1Z",
  fill: "#E4761B",
  stroke: "#E4761B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9591 12.5938L12.2947 15.3411L15.853 16.3938L16.8731 12.6516L13.9591 12.5938Z",
  fill: "#E4761B",
  stroke: "#E4761B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.13181 12.6516L2.14706 16.3938L5.70533 15.3411L4.0409 12.5938L1.13181 12.6516Z",
  fill: "#E4761B",
  stroke: "#E4761B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.50516 7.95115L4.51431 9.56693L8.04818 9.73535L7.92127 5.64062L5.50516 7.95115Z",
  fill: "#E4761B",
  stroke: "#E4761B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4899 7.95164L10.0396 5.59375L9.96155 9.73584L13.4856 9.56743L12.4899 7.95164Z",
  fill: "#E4761B",
  stroke: "#E4761B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.70529 15.3428L7.82854 14.227L5.99327 12.6797L5.70529 15.3428Z",
  fill: "#E4761B",
  stroke: "#E4761B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1665 14.227L12.2947 15.3428L12.0018 12.6797L10.1665 14.227Z",
  fill: "#E4761B",
  stroke: "#E4761B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2947 15.3423L10.1665 14.2266L10.3374 15.7213L10.3179 16.3476L12.2947 15.3423Z",
  fill: "#D7C1B3",
  stroke: "#D7C1B3",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M5.70529 15.3423L7.68211 16.3476L7.66746 15.7213L7.82854 14.2266L5.70529 15.3423Z",
  fill: "#D7C1B3",
  stroke: "#D7C1B3",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M7.71142 11.6946L5.94449 11.1314L7.19403 10.5156L7.71142 11.6946Z",
  fill: "#233447",
  stroke: "#233447",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2788 11.6946L10.8011 10.5156L12.0555 11.1314L10.2788 11.6946Z",
  fill: "#233447",
  stroke: "#233447",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M5.70532 15.3411L6.00795 12.5938L4.04089 12.6516L5.70532 15.3411Z",
  fill: "#CD6116",
  stroke: "#CD6116",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9921 12.5938L12.2947 15.3411L13.9591 12.6516L11.9921 12.5938Z",
  fill: "#CD6116",
  stroke: "#CD6116",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4856 9.57031L9.96155 9.73873L10.2886 11.6966L10.806 10.5177L12.0604 11.1335L13.4856 9.57031Z",
  fill: "#CD6116",
  stroke: "#CD6116",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M5.94445 11.1335L7.19888 10.5177L7.71138 11.6966L8.04818 9.73873L4.51431 9.57031L5.94445 11.1335Z",
  fill: "#CD6116",
  stroke: "#CD6116",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M4.51431 9.57031L5.99326 12.6809L5.94445 11.1335L4.51431 9.57031Z",
  fill: "#E4751F",
  stroke: "#E4751F",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0604 11.1335L12.0018 12.6809L13.4857 9.57031L12.0604 11.1335Z",
  fill: "#E4751F",
  stroke: "#E4751F",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M8.04822 9.73438L7.71143 11.6923L8.12631 13.9976L8.22393 10.9607L8.04822 9.73438Z",
  fill: "#E4751F",
  stroke: "#E4751F",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M9.96158 9.73438L9.79074 10.9554L9.86396 13.9976L10.2886 11.6923L9.96158 9.73438Z",
  fill: "#E4751F",
  stroke: "#E4751F",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2886 11.696L9.86392 14.0012L10.1666 14.2275L12.0018 12.6802L12.0604 11.1328L10.2886 11.696Z",
  fill: "#F6851B",
  stroke: "#F6851B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M5.94449 11.1328L5.9933 12.6802L7.82856 14.2275L8.12631 14.0012L7.71142 11.696L5.94449 11.1328Z",
  fill: "#F6851B",
  stroke: "#F6851B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3179 16.3491L10.3374 15.7227L10.1812 15.57H7.81389L7.66746 15.7227L7.68211 16.3491L5.70529 15.3438L6.39352 15.949L7.79437 17.0017H10.2007L11.6065 15.949L12.2947 15.3438L10.3179 16.3491Z",
  fill: "#C0AD9E",
  stroke: "#C0AD9E",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1666 14.2263L9.86394 14H8.1263L7.82855 14.2263L7.66748 15.721L7.81391 15.5684H10.1812L10.3374 15.721L10.1666 14.2263Z",
  fill: "#161616",
  stroke: "#161616",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M16.468 6.32631L17 3.56841L16.2044 1L10.1665 5.83157L12.4899 7.95262L15.77 8.9842L16.4973 8.07368L16.1849 7.83157L16.6876 7.33684L16.2971 7.01052L16.7999 6.59999L16.468 6.32631Z",
  fill: "#763D16",
  stroke: "#763D16",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M1 3.56841L1.53203 6.32631L1.19524 6.59999L1.69799 7.01052L1.31239 7.33684L1.81513 7.83157L1.50275 8.07368L2.22514 8.9842L5.50519 7.95262L7.82855 5.83157L1.79073 1L1 3.56841Z",
  fill: "#763D16",
  stroke: "#763D16",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M15.77 8.98471L12.4899 7.95312L13.4857 9.56891L12.0018 12.6794L13.9591 12.6531H16.8731L15.77 8.98471Z",
  fill: "#F6851B",
  stroke: "#F6851B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5052 7.95312L2.22515 8.98471L1.13181 12.6531H4.0409L5.99331 12.6794L4.51436 9.56891L5.5052 7.95312Z",
  fill: "#F6851B",
  stroke: "#F6851B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M9.96154 9.73889L10.1665 5.83364L11.1232 3.05469H6.88651L7.82853 5.83364L8.04819 9.73889L8.12139 10.9705L8.12627 14.0021H9.86392L9.87856 10.9705L9.96154 9.73889Z",
  fill: "#F6851B",
  stroke: "#F6851B",
  strokeWidth: 0.0502197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.cb4777f959262ee9d34b5ce4ca2f6e20.svg";
export { ForwardRef as ReactComponent };